module.exports = __webpack_public_path__ + "static/media/pics11.aa63cd56.jpg";